import IconWrapper from "./IconWrapper";
import { ReactComponent as StickerIcon } from "../../../icons/sticker.svg";
import { Box, SxProps, Typography, TypographyProps } from "@mui/material";
import { getInitials } from "../../../helpers/getInitials";

type Props = {
  stickerSx?: SxProps;
  name?: string;
  // TODO: add image type when we have it in CORE
  image?: any;
  TypographyProps?: TypographyProps;
};

const StickerAvatar = ({
  stickerSx,
  name,
  image = null,
  TypographyProps = {},
}: Props) => {
  return (
    <Box
      position="relative"
      width="fit-content"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <IconWrapper
        icon={StickerIcon}
        sx={{
          width: "48px",
          height: "48px",
          ...stickerSx,
        }}
      />
      <span
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        {/*  TODO: render image (when we have it in CORE) if passed */}
        {image}
        {name && !image && (
          <Typography
            variant="header"
            color="#fff"
            fontWeight={600}
            {...TypographyProps}
          >
            {getInitials(name)}
          </Typography>
        )}
      </span>
    </Box>
  );
};

export default StickerAvatar;
